var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLobbyOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lobby",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.906,
    height: 60.906,
    viewBox: "0 0 60.906 60.906",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #006533;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    className: "cls-1",
    d: "M217.224,348.067a1.458,1.458,0,1,0,1.03-.427A1.458,1.458,0,0,0,217.224,348.067Z",
    transform: "translate(-190.63 -305.681)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    className: "cls-1",
    d: "M438.931,393.55a1.459,1.459,0,1,0,1.03.428A1.459,1.459,0,0,0,438.931,393.55Z",
    transform: "translate(-385.893 -346.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "cls-1",
    d: "M59.716,31.643H54.478v-9.98a5.969,5.969,0,0,0-4.657-5.795l-3.888-.853a6.226,6.226,0,0,0,2.183-4.735V6.24a6.24,6.24,0,1,0-12.481,0v4.042a6.225,6.225,0,0,0,2.179,4.731l-3.889.852a5.969,5.969,0,0,0-4.661,5.795v5.223H22.84a1.191,1.191,0,0,0-1.19,1.19v3.569H13.324V28.311h4.994a1.19,1.19,0,0,0,1.19-1.189V14.275a1.19,1.19,0,0,0-1.19-1.19H1.19A1.189,1.189,0,0,0,0,14.275V27.123a1.189,1.189,0,0,0,1.19,1.189H6.184v3.332H1.19A1.189,1.189,0,0,0,0,32.832v5.711a1.189,1.189,0,0,0,1.19,1.189H5.238V59.716a1.189,1.189,0,0,0,1.185,1.19H54.483a1.189,1.189,0,0,0,1.189-1.19V53.887a1.19,1.19,0,0,0-2.379,0v4.64H7.613v-13.8H22.84a1.19,1.19,0,1,0,0-2.379H7.613V39.731H53.292v4.64a1.19,1.19,0,0,0,2.379,0v-4.64h4.044a1.189,1.189,0,0,0,1.19-1.189V32.832a1.189,1.189,0,0,0-1.19-1.189Zm-21.7-22.2h1.637a10.942,10.942,0,0,0,6.091-1.827v2.67a3.861,3.861,0,1,1-7.723,0Zm3.861,7.083a6.244,6.244,0,0,0,1.085-.1l-1.1,2.478-1.1-2.484A6.256,6.256,0,0,0,41.873,16.522Zm0-14.144A3.868,3.868,0,0,1,45.46,4.815a8.58,8.58,0,0,1-5.812,2.25H38.011V6.24A3.866,3.866,0,0,1,41.873,2.379ZM31.64,21.66a3.573,3.573,0,0,1,2.791-3.47l4.105-.9,2.233,5.027a1.19,1.19,0,0,0,2.174,0l2.233-5.028,4.131.9a3.572,3.572,0,0,1,2.793,3.47v9.98H39.256V28.074a1.191,1.191,0,0,0-1.19-1.19H31.643Zm-7.613,7.6H36.876v2.38H24.03ZM2.379,15.47h14.75V25.938H13.3a3.569,3.569,0,0,0-7.1,0H2.379ZM8.565,26.311a1.19,1.19,0,1,1,2.379,0v5.344H8.565ZM58.527,37.364H2.379V34.022H58.527Z",
    transform: "translate(0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLobbyOrange);
export default __webpack_public_path__ + "static/media/Lobby_orange.b6aa407f07a5b7a59a7fe079f4374b0d.svg";
export { ForwardRef as ReactComponent };